import React, { Component } from 'react'
import styled from 'styled-components'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import Input from '../UI/Form/Input'
// import Select from '../UI/Form/Select'
import Select from '../UI/Form/ReactSelect'
import { required, number, maxLength, minLength } from '../../utils/validators'
import { device } from '../../utils/helpers'
import { fetchLogisticsAmount } from '../../actions/calculator'

// Length Validators
const maxLength5 = maxLength(5)
const minLength5 = minLength(5)

const Wrapper = styled.div`
  width: 100%;
`

const MobileForm = styled.div`
  @media ${device.tablet} {
    display: none;
  }
`

const DesktopForm = styled.div`
  display: none;

  @media ${device.tablet} {
    display: block;
  }
`

const FormGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: ${props => props.margin};
`

const ExclaimIcon = styled.div`
  font-size: 45px;
  font-family: 'BarlowExtraBold';
  font-weight: 700;
  color: #fff;
  padding-right: 18px;

  @media ${device.tablet} {
    font-size: 2.34375VW;
  }
`

const ErrorText = styled.p`
  font-size: 12px;
  line-height: 1.25em;
  color: #fff;

  @media ${device.tablet} {
    font-size: 9px;
    line-height: 1em;
  }

  @media ${device.laptop} {
    font-size: 12px;
    line-height: 1em;
  }
`

const Error = styled.div`
  display: flex;
  background-color: #e2e2e2;
  padding: 15px 0;
  justify-content: center;
  width: 100%;
  background-color: ${props => props.theme.color.bgYellow};

  @media ${device.tablet} {
    width: 65%;
    margin-left: 0.4166666666666667vw;
    padding: 0.78125VW 0;
  }
`

const LastGroup = styled.div`
  display: flex;
  align-items: flex-end;
`

let Form = class Form extends Component {
  handleFormSubmit (values) {
    console.log(values)
  }

  // handleZipcodeEntry (e) {
  //   if (e.target.value.length === 5) {
  //     this.props.fetchLogisticsAmount(e.target.value)
  //   }
  // }

  // Returns the selected value in the Dropdown
  getSelection (data) {
    console.log(data.name)
    // Pass value to parent
    this.props.updateProvince(data.name)
  }

  render () {
    const { provinces, error, logisticsAmount } = this.props
    return (
      <Wrapper>
        <MobileForm>
          <FormGroup margin='10px 0'>
            <Field
              name='address'
              required
              component={Input}
              type='text'
              width='75%'
              label='Indirizzo'
              validate={[required]}
            />
            <Field
              name='street'
              required
              component={Input}
              type='text'
              width='25%'
              label='Civico'
              validate={[required, number]}
              padding='0 0 0 10px'
            />
          </FormGroup>
          <FormGroup margin='10px 0'>
            <Field
              name='zipcode'
              required
              component={Input}
              type='text'
              width='35%'
              label='Cap'
              validate={[required, maxLength5, minLength5, number]}
              // onChange={this.handleZipcodeEntry.bind(this)}
            />
            <Field
              name='city'
              required
              component={Input}
              type='text'
              width='65%'
              label='Comune'
              validate={[required]}
              padding='0 0 0 10px'
            />
          </FormGroup>
          <FormGroup margin='15px 0'>
            <Field
              name='province'
              required
              component={Select}
              type='text'
              width='42%'
              label='Prov'
              validate={[required]}
              options={provinces}
              valueKey='id'
              labelKey='name'
            />
          </FormGroup>
          {(error || logisticsAmount < 1) && <Error>
            <ExclaimIcon>!</ExclaimIcon>
            <ErrorText>Il trasporto non è disponibile per questa località. <br />Vai all’ultimo step del preventivo.</ErrorText>
          </Error>}
        </MobileForm>
        <DesktopForm>
          <FormGroup margin='0.4166666666666667vw 0'>
            <Field
              name='address'
              required
              component={Input}
              type='text'
              width='80%'
              label='Indirizzo'
              validate={[required]}
            />
            <Field
              name='street'
              required
              component={Input}
              type='text'
              width='20%'
              label='Civico'
              validate={[required, number]}
              padding='0 0 0 0.4166666666666667vw'
            />
          </FormGroup>
          <FormGroup margin='0.4166666666666667vw 0'>
            <Field
              name='zipcode'
              required
              component={Input}
              type='text'
              width='45%'
              label='Cap'
              validate={[required, maxLength5, minLength5, number]}
              // onChange={this.handleZipcodeEntry.bind(this)}
            />
            <Field
              name='city'
              required
              component={Input}
              type='text'
              width='60%'
              label='Comune'
              validate={[required]}
              padding='0 0 0 0.4166666666666667vw'
            />
          </FormGroup>
          <LastGroup>
            <Field
              name='province'
              required
              component={Select}
              type='text'
              width='42%'
              label='Prov'
              validate={[required]}
              options={provinces}
              valueKey='id'
              labelKey='name'
            />
            {(error || logisticsAmount < 1) && <Error>
              <ExclaimIcon>!</ExclaimIcon>
              <ErrorText>Il trasporto non è disponibile per questa località. <br />Vai all’ultimo step del preventivo.</ErrorText>
            </Error>}
          </LastGroup>
        </DesktopForm>
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  let address = state.calculator.steps[4].address || {}
  console.log(address)
  return {
    success: state.calculator.success,
    error: state.calculator.error,
    logisticsAmount: state.calculator.logisticsAmount,
    initialValues: state.calculator.steps[4].address ? {
      province: address.province || '',
      zipcode: address.zipcode || '',
      street: address.street || '',
      address: address.address || '',
      city: address.city || ''
    } : {}
  }
}

Form = reduxForm({
  form: 'LogisticsForm', // a unique identifier for this form
  enableReinitialize: true
})(Form)

Form = connect(mapStateToProps, { fetchLogisticsAmount })(Form)

export default (Form)



// WEBPACK FOOTER //
// ./src/components/Forms/Logistics.js